export default __webpack_public_path__ + "static/Where-Do-My-Taxes-and-Fees-Go-Infographic-cc32a71d3014deb363e777c11e49af67.pdf";